module.exports = __webpack_public_path__ + "static/media/enabledHorizontalTicketIcon.6f89083b.svg";